import React, { useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import ReservationListFields from "../../../constants/DeliveryDrivers/ReservationListFields.json";
import variables from "../../../constants/assets/variables";
import BlankState from "../../Common/BlankState";
import { FieldsContainer, Pill } from "../../../constants/assets/containers";

const DriverReservationDetails = ({
  driverReservationDetails,
  getDriverReservationDetails,
}) => {
  const { id } = useParams();

  const handleUserClick = (userId) => {
    const baseUrl = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            "/admin"
          )}`
        : ""
    }`;
    window.open(baseUrl + `/users/${userId}`);
  };

  const handleReservationRedirect = (reservationId) => {
    const baseUrl = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            ""
          )}`
        : ""
    }`;
    window.open(baseUrl + `/driver_reservations/reservations/${reservationId}`);
  };

  const getFieldValue = (field, key) => {
    if (key === "users") {
      return (
        <span className="edit-options cursor-pointer">
          {field[key].map((user, index) => {
            return (
              <React.Fragment>
                {index === 0 && <span>[</span>}
                <span onClick={() => handleUserClick(user.id)}>
                  {user["name"]}
                </span>
                {index !== field[key].length - 1 && <span>,</span>}
                {index === field[key].length - 1 && <span>]</span>}
              </React.Fragment>
            );
          })}
        </span>
      );
    } else if (key === "actions") {
      return (
        <span
          onClick={() => handleReservationRedirect(field.id)}
          className="edit-options cursor-pointer"
        >
          <u>Show</u>
        </span>
      );
    } else if (key === "active") {
      return <Pill isFalse={!field[key]}>{field[key] ? "Yes" : "No"}</Pill>;
    } else return field[key];
  };

  useEffect(() => {
    if (driverReservationDetails.length === 0) {
      getDriverReservationDetails(id);
    }
  }, []);

  return (
    <DriverReservationDetailsContainer>
      <FieldsContainer>
        <FieldHolder className="grid-display" repeat={7} display="grid">
          {ReservationListFields.map((field, index) => {
            return <span key={index}>{field.name}</span>;
          })}
        </FieldHolder>
        {driverReservationDetails.length > 0 ? (
          driverReservationDetails.map((reservation, index) => {
            return (
              <FieldHeading className="grid-display" repeat={7} display="grid">
                {ReservationListFields.map((field, idx) => {
                  return (
                    <span key={index + idx}>
                      {getFieldValue(reservation, field.key)}
                    </span>
                  );
                })}
              </FieldHeading>
            );
          })
        ) : (
          <BlankState message=" " />
        )}
      </FieldsContainer>
    </DriverReservationDetailsContainer>
  );
};

const DriverReservationDetailsContainer = styled(DriverBasicDetailsContainer)`
  .edit-options {
    text-decoration: unset;
    color: ${variables.primaryColor};
    & span {
      text-decoration: underline;
      color: ${variables.primaryColor};
      &:hover {
        text-decoration: unset;
      }
    }
  }
  .grid-display {
    grid-template-columns: 1fr 2fr repeat(5, 1fr);
  }
`;

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.black};
    word-break: break-all;
  }
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverReservationDetails: DeliveryDrivers.driverReservations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverReservationDetails: bindActionCreators(
      DeliveryDriversActions.getDriverReservationDetails,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverReservationDetails);
